export default __webpack_public_path__ + "static/media/undraw_feeling_blue_4b7q.83a3033e.png";